var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41337_131554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.39844 5.78906H11.8055C12.0503 5.78906 12.2865 5.87885 12.4696 6.0414L13.5269 6.98057C13.7406 7.17035 13.8628 7.44246 13.8628 7.72823V11.5871C13.8628 12.1394 13.4151 12.5871 12.8628 12.5871H9.39844C8.84615 12.5871 8.39844 12.1394 8.39844 11.5871V6.78906C8.39844 6.23678 8.84615 5.78906 9.39844 5.78906Z",
    stroke: "#8B93A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2613 12.9045V13.4982C11.2613 14.1017 10.772 14.591 10.1684 14.591H6.88976C6.28617 14.591 5.79688 14.1017 5.79688 13.4982V8.88585C5.79688 8.28227 6.28617 7.79297 6.88976 7.79297H8.14342",
    stroke: "#8B93A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4062 5.78906V7.63225C11.4062 7.85316 11.5853 8.03225 11.8062 8.03225H13.8574",
    stroke: "#8B93A7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.77900eb3ad3c6662fc6ef23faf53fa8a.svg";
export { ForwardRef as ReactComponent };